const theme = {
  font: {
    family: {
      inter: "Inter",
      publicSans: "Public Sans"
    },
    size: {
      xs: "12px",
      sm: "14px",
      md: "16px",
      lg: "18px",
      xl: "20px",
      xl2: "24px",
      xl3: "30px",
      xl4: "36px",
      xl5: "48px"
    },
    weight: {
      light: "300",
      regular: "400",
      medium: "500",
      semiBold: "600",
      bold: "700",
      extraBold: "800",
      heavy: "900"
    }
  },
  colors: {
    brand: {
      primary: "#d81a67",
      secondary: "#5da1a9",
      green: "#58a68a",
      red: "#eb5757",
      yellow: "#f59f00"
    },
    neutral: {
      white: "#ffffff",
      gray0: "#f8f9fa",
      gray1: "#f1f3f5",
      gray2: "#e9ecef",
      gray3: "#dee2e6",
      gray4: "#ced4da",
      gray5: "#adb5bd",
      gray6: "#868e96",
      gray7: "#495057",
      gray8: "#343a40",
      gray9: "#212529"
    }
  },
  radius: {
    xs: "4px",
    sm: "8px",
    md: "12px",
    lg: "16px"
  }
};

export default theme;
